<template>
  <div>

    <el-dialog class="my-el-dialog" :visible.sync="visible" :width="dialogWidth" :close-on-click-modal='false'
      @closed="closed" @close="$emit('update:Loginshow', false)" :show="Loginshow" :lock-scroll="false">
      <!--登录窗口title部分  -->
      <div slot="title" class="dialog-title"><img src="../assets/images/solapassport.png" alt="SOLApassport">
        <p>{{ LoginTitle }}</p>
      </div>

      <!-- 登录部分 -->
      <div v-if="LoginGo">
        <el-tabs v-model="loginType" :stretch="true">
          <!-- 手机 -->
          <el-tab-pane label="số di động" name="SMS">
            <div class="DisplayFlex">
              <!-- 账号 -->
              <!-- <span>{{$t('login.account')}}：</span> -->
              <!-- 请输入账号 -->
              <el-input v-model="phoneNumber" maxlength="10" type="tel" placeholder="Hãy nhập số di động"></el-input>
            </div>
            <div class="DisplayFlex" style="margin-bottom:0;">
              <!-- 密码 -->
              <!-- <span>{{$t('login.password')}}：</span> -->
              <!-- 请输入密码 -->
              <el-input v-model="LoginPassWord" type='password'
                :placeholder="$t('login.passwordplaceholder')"></el-input>
            </div>
          </el-tab-pane>
          <el-tab-pane label="email" name="EMAIL">
            <div class="DisplayFlex">
              <!-- 账号 -->
              <!-- <span>{{$t('login.account')}}：</span> -->
              <!-- 请输入账号 -->
              <el-input v-model="LoginEmail" :placeholder="$t('login.accountplaceholder')"></el-input>
            </div>
            <div class="DisplayFlex" style="margin-bottom:0;">
              <!-- 密码 -->
              <!-- <span>{{$t('login.password')}}：</span> -->
              <!-- 请输入密码 -->
              <el-input v-model="LoginPassWord" type='password'
                :placeholder="$t('login.passwordplaceholder')"></el-input>
            </div>
          </el-tab-pane>
        </el-tabs>

        <div class="TipsText">
          <span>{{ ErrorTips }}</span>
          <!-- 重置密码 -->
          <!-- <p @click="RegisterGoBtn('wjmm')">
            <em>{{$t('login.forpassword')}}</em>
          </p> -->
        </div>
        <div class="DisplayFlex loginbtn">
          <!-- 登入 -->
          <el-button type="danger" @click="Login()">{{ $t('login.sign') }}</el-button>
          <el-button class="registerBtn" type="danger" @click="RegisterGoBtn('zc')">{{ $t('login.register')
          }}</el-button>
        </div>
        <!-- <p class="agre"
           @click="toArge">Đăng ký ngay</p> -->
        <div class="moreWaysLogin">
          <moreWays @childs="childs" />
        </div>
      </div>
      <!-- 老注册逻辑--注册发送验证码 -->
      <div class="Reg-box" v-if="RegisterGoOLD">
        <div class="DisplayFlex">
          <!-- 账号 -->
          <!-- <span>{{$t('login.account')}}：</span> -->
          <!-- 请输入电子邮件地址 -->
          <el-input v-model="RegisterCode" :placeholder="$t('login.emailplaceholder')"></el-input>
        </div>
        <div class="TipsText">
          <span>{{ ErrorTips }}</span>
        </div>
        <div class="DisplayFlex">
          <el-button type="danger" @click="RegisterCodeBtn()">{{ RegisterClassBtnText }}</el-button>
        </div>
        <div class="LoginPassWord">
          <!-- 登入 -->
          <el-button class="registerBtn" type="danger" @click="LoginGoBtn()">{{ $t('login.sign') }}</el-button>
          <!-- <span class="CursorPointer"
                @click="LoginGoBtn()">{{$t('login.sign')}}</span> -->
          <!-- @click="RegisterGoBtn(LoginTitle === '忘记密码'? 'zc' : 'wjmm')">{{LoginTitle === '忘记密码'? '注册' : '忘记密码'}}</span> -->
          <!-- <span class="CursorPointer"
                @click="RegisterGoBtn(LoginTitle === $t('login.forpassword')? 'zc' : 'wjmm')">{{LoginTitle === $t('login.forpassword')? $t('login.register') : $t('login.forpassword')}}</span> -->
        </div>
      </div>
      <!-- 新注册逻辑不需要校验 -->
      <div class="setPassWord-box" v-if="RegisterGo">
        <el-tabs v-model="registerType" :stretch="true">
          <!-- 手机 -->
          <el-tab-pane label="số di động" name="SMS">
            <div class="DisplayFlex">
              <div class="SetPassWordCont">
                <!-- 请输入手机号 -->
                <el-input v-model="phoneNumber" maxlength="10" type="tel" placeholder="Hãy nhập số di động"></el-input>
                <!-- 输入验证码 -->
                <el-input v-model="registerPhoneCode" maxlength="6" type="tel" class="code"
                  placeholder="Nhập mã kiểm chứng">
                  <template #suffix>
                    <el-button class="NextCodeTop" type="danger"
                      style="border: none;margin-top: 5px;width: 60px;padding: 8px 0;" @click="getCode"
                      :loading="getCodeBtnLoading">
                      <!-- <el-button @click="getCode" style="border: none"> -->
                      <!-- 发送验证码&倒计时 -->
                      <span v-show="!getCodeShow">Gửi</span>
                      <span v-show="getCodeShow" class="count">{{ getCodeCount }} s</span>
                    </el-button>
                  </template>
                </el-input>
                <el-radio-group :disabled="getCodeShow" fill="#f56c6c" style="width: 80%;" size="small"
                  v-model="codeChannelRadio">
                  <el-radio-button label="ZNS"></el-radio-button>
                  <el-radio-button label="SMS"></el-radio-button>
                </el-radio-group>
                <!-- 登入密码 -->
                <el-input type='password' v-model="SetPassWord" :placeholder="$t('login.signPassword')"></el-input>
                <!-- 重复登入密码 -->
                <el-input type='password' v-model="SetEndPassWord" :placeholder="$t('login.resignPassword')"></el-input>
              </div>
              <!-- 密码为6至9位字母、数字组合 -->
              <div class="RegisterEmailText" style="font-size: 12px;">{{ $t('login.setpasswordTip') }}</div>
            </div>
          </el-tab-pane>
          <!-- 邮箱 -->
          <el-tab-pane label="email" name="EMAIL">
            <div class="DisplayFlex">
              <div class="SetPassWordCont">
                <!-- 请输入电子邮件地址 -->
                <el-input v-model="RegisterCode" placeholder="Hãy nhập email"></el-input>
                <!-- 登入密码 -->
                <el-input type='password' v-model="SetPassWord" :placeholder="$t('login.signPassword')"></el-input>
                <!-- 重复登入密码 -->
                <el-input type='password' v-model="SetEndPassWord" :placeholder="$t('login.resignPassword')"></el-input>
              </div>
              <!-- 密码为6至9位字母、数字组合 -->
              <div class="RegisterEmailText" style="font-size: 12px;">{{ $t('login.setpasswordTip') }}</div>
            </div>
          </el-tab-pane>
        </el-tabs>

        <div v-if="ErrorTips" class="TipsText">
          <span style="text-align: center">{{ ErrorTips }}</span>
        </div>
        <div class="DisplayFlex">
          <!-- 确认 -->
          <el-button class="NextCodeTop" type="danger" @click="newSetUpSuccessBtn()">{{ $t('login.confirm')
          }}</el-button>
          <!-- 登入 -->
          <el-button class="registerBtn" type="danger" @click="LoginGoBtn()">{{ $t('login.sign') }}</el-button>
        </div>
      </div>
      <!-- 验证邮箱 -->
      <div class="vcode-box" v-if="RegisterCodeGo">
        <div class="DisplayFlex">
          <!-- 请输入四位验证码 -->
          <div class="RegisterCodeText">{{ $t('login.RegisterCodeText') }}</div>
          <!-- 验证码已发送至 -->
          <div class="RegisterEmailText">{{ $t('login.RegisterEmailText') }} {{ RegisterCode }}</div>
          <div class="code-input-main">
            <div class="code-input-main-item" v-for="(item, int) in 4" :key='int'
              :class="int === 0 || int == code.length || int < code.length ? 'code-input-main-item-border' : ''">
              {{ code[int] }}</div>
            <el-input class="code-input-input" ref='CodeInputs' maxlength="4" v-model="code" type="tel"></el-input>
          </div>
          <!-- '重新发送' ? -->
          <div class="RegisterEmailText" :class="second == $t('login.resend') ? 'CursorPointer' : ''"
            @click="second == $t('login.resend') ? ResendBtn() : false">{{ second }}</div>
        </div>
        <div class="TipsText">
          <span>{{ ErrorTips }}</span>
        </div>
        <div class="DisplayFlex NextCodeTop">
          <!-- 上一步 -->
          <el-button type="danger" @click='RegisterGoBtn("zc")'>{{ $t('login.previousStep') }}</el-button>
          <!-- 下一步 -->
          <el-button type="success" @click="SetPassWordBtn()">{{ $t('login.nextStep') }}</el-button>
        </div>
      </div>
      <!-- 注册设置密码 -->
      <div class="setPassWord-box" v-if="SetPassWordGo">
        <div class="DisplayFlex">
          <!-- 请设置登入密码 -->
          <div class="RegisterCodeText">{{ $t('login.setpassword') }}</div>
          <!-- 密码为6至9位字母、数字组合 -->
          <div class="RegisterEmailText">{{ $t('login.setpasswordTip') }}</div>
          <div class="SetPassWordCont">
            <!-- 登入密码 -->
            <el-input type='password' v-model="SetPassWord" :placeholder="$t('login.signPassword')"></el-input>
            <!-- 重复登入密码 -->
            <el-input type='password' v-model="SetEndPassWord" :placeholder="$t('login.resignPassword')"></el-input>
          </div>
        </div>
        <div class="TipsText">
          <span>{{ ErrorTips }}</span>
        </div>
        <div class="DisplayFlex">
          <!-- 确认 -->
          <el-button class="NextCodeTop" type="success" @click="SetUpSuccessBtn()">{{ $t('login.confirm') }}</el-button>
        </div>

        <!-- 注册 -->
        <!-- <div class="LoginPassWord">
          <span class="CursorPointer"
                @click="RegisterGoBtn('zc')">{{$t('login.register')}}</span>
        </div> -->
      </div>
      <!-- 设置密码成功 -->
      <div v-if="SetUpSuccessGo">
        <div class="DisplayFlex SetUpSuccessIcon">
          <span class="el-icon-circle-check"></span>
          <!-- '已发送重置密码邮件，请根据提示操作' : '设置登入密码成功' -->
          <div>{{ SetSuccessText === 'wjmm' ? $t('login.resignPasswordSendSuccessText') :
            $t('login.SetresignPasswordSuccessText') }}</div>
        </div>
        <div class="DisplayFlex">
          <!-- 前往登入 -->
          <el-button class="NextCodeTop" type="success" @click="LoginGoBtn()">{{ $t('login.toSign') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moreWays from '@/components/module/moreWays'
export default {
  components: {
    moreWays
  },
  name: 'login',
  props: {
    Loginshow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loginType: 'SMS',//登录方式
      registerType: 'SMS',//注册方式
      phoneNumber: '',//手机号
      registerPhoneCode: '',//手机验证码
      getCodeBtnLoading: false,
      getCodeCount: "",//短信验证码倒计时
      codeChannelRadio: 'ZNS',//短信通道
      getCodeShow: false,
      fullscreenLoading: null,
      dialogWidth: '',
      visible: this.Loginshow,
      LoginTitle: this.$t('login.sign'),//'登入',
      LoginGo: true, // 登入
      RegisterGo: false, // 注册/忘记密码
      RegisterGoOLD: false,//老注册逻辑-暂时改为这个
      SetPassWordGo: false, // 设置密码
      RegisterCodeGo: false, // 输入验证码
      SetUpSuccessGo: false, // 设置密码成功
      RegisterClassBtnText: '', // 注册/忘记密码文本
      SetSuccessText: '',
      ErrorTips: '', // 错误提示
      code: '', // 验证码
      LoginEmail: '', // 账号
      LoginPassWord: '', // 登入密码
      SetPassWord: '', // 设置密码
      SetEndPassWord: '', // 确认密码
      interval: null, // 定时器
      second: this.$t('login.resend60s'),//'60秒后可重新发送', // 验证码重新发送倒计时
      RegisterCode: '', // 注册发送验证码input
      captchaFlowNo: null // 验证码流水号
    }
  },
  created() {

  },
  watch: {
    Loginshow() {
      this.visible = this.Loginshow
    }
  },
  methods: {
    openFullScreen() {
      this.fullscreenLoading = this.$loading({
        lock: true
      });
    },
    childs(data) {
      this.visible = data
    },
    RegisterCodeBtn() { // 注册邮箱发送验证码
      // eslint-disable-next-line no-useless-escape
      let EmailReg = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/ // 邮箱正则
      if (!EmailReg.test(this.RegisterCode)) {
        this.ErrorTips = this.$t('login.emailTip') //'请输入正确的电子邮件'
        return
      }
      let url
      let data
      if (this.LoginTitle === this.$t('login.register') || this.LoginTitle === this.$t('login.vcode')) {// 注册||验证码
        url = this.apiUrl.API.VerificationCode
        data = {
          email: this.RegisterCode,
          type: 'REG'
        }
      } else {
        //找回密码
        url = this.apiUrl.API.ForgetPwd
        data = {
          email: this.RegisterCode,
          forgetPwdUrl: location.origin + '/reSetPassword?token='
        }
      }
      this.$axios.post(url, data)
        .then((res) => {
          if (res.data.resCode === 'C502570000000') {
            if (this.LoginTitle === this.$t('login.register') || this.LoginTitle === this.$t('login.vcode')) { // 注册||验证码
              this.captchaFlowNo = res.data.captchaFlowNo // 验证码流水号
              this.RegisterCodeGoBtn()
              this.CodeChangFouce()
            } else { // 忘记密码
              this.SetSuccessText = 'wjmm'
              this.LogInShow(false, false, false, false, true)
            }
          } else {
            this.ErrorTips = res.data.resMsg
          }
        })
    },
    SetPassWordBtn() { // 注册设置密码弹出框显示
      this.$axios.post(this.apiUrl.API.InspectVerificationCode, {
        captchaCode: this.code,
        captchaFlowNo: this.captchaFlowNo
      })
        .then((res) => {
          if (res.data.resCode === 'C502570000000') {
            this.LoginTitle = this.$t('login.setpasswordtext')//'设置密码'
            this.LogInShow(false, false, false, true, false)
            this.ErrorTips = '' // 错误信息清空
          } else {
            this.ErrorTips = res.data.resMsg
          }
        })
    },
    newSetUpSuccessBtn() { // 设置密码成功弹出框显示
      let that = this
      // 注册类型
      if (this.registerType == 'SMS') {
        let reg1 = /^\d{10}$/
        if (!reg1.test(this.phoneNumber)) {
          this.ErrorTips = "Vui lòng nhập số điện thoại 10 chữ số"//请输入10位手机号码
          return
        }
        let reg2 = /^\d{6}$/
        if (!reg2.test(this.registerPhoneCode)) {
          this.ErrorTips = "Nhập mã kiểm chứng"//请输入验证码
          return
        }
        let PassWordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,9}$/ // 6-9位数字字母混合正则验证
        if (!PassWordReg.test(this.SetPassWord)) {
          this.ErrorTips = this.$t('login.passwordTip')//'请输入正确格式密码'
          return
        }
        if (!PassWordReg.test(this.SetPassWord)) {
          this.ErrorTips = this.$t('login.passwordTip')//'请输入正确格式密码'
          return
        }
        if (this.SetPassWord !== this.SetEndPassWord) {
          this.ErrorTips = this.$t('login.passwordErrorTip')//'密码输入不一致'
          return
        }
        this.ErrorTips = ""
        // 验证短信验证码
        this.openFullScreen()
        this.$axios.post(this.apiUrl.API.verfiyCaptchasms, {
          captchaCode: this.registerPhoneCode,
          smsType: this.codeChannelRadio,
          mobile: this.phoneNumber
        }).then((res) => {
          if (res.data.resCode === 'C502570000000') {
            this.openFullScreen()
            this.$axios.post(this.apiUrl.API.RegisterReg, {
              regType: this.registerType,
              mobile: this.phoneNumber,
              captchaFlowNo: "",
              loginPwd: this.SetPassWord,
              captchaCode: ""
            }).then((res) => {
              that.fullscreenLoading.close();
              if (res.data.resCode === 'C502570000000') {
                this.LoginTitle = this.$t('login.SetSuccessText')//'设置成功'
                this.$store.commit('login', res);
                this.visible = false
              }
            }).catch(function (error) {
              that.fullscreenLoading.close();
            });
          }
        }).catch(function (error) {
          that.fullscreenLoading.close();
        });
      } else if (this.registerType == 'EMAIL') {
        if (!this.RegisterCode) {
          this.ErrorTips = 'Nhập tên tài khoản' //'请输入账户名称'
          return
        }
        let PassWordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,9}$/ // 6-9位数字字母混合正则验证
        if (!PassWordReg.test(this.SetPassWord)) {
          this.ErrorTips = this.$t('login.passwordTip')//'请输入正确格式密码'
          return
        }
        if (!PassWordReg.test(this.SetPassWord)) {
          this.ErrorTips = this.$t('login.passwordTip')//'请输入正确格式密码'
          return
        }
        if (this.SetPassWord !== this.SetEndPassWord) {
          this.ErrorTips = this.$t('login.passwordErrorTip')//'密码输入不一致'
          return
        }
        this.ErrorTips = ""
        this.openFullScreen()
        this.$axios.post(this.apiUrl.API.RegisterReg, {
          regType: this.registerType,
          email: this.RegisterCode,
          captchaFlowNo: "",
          loginPwd: this.SetPassWord,
          captchaCode: ""
        }).then((res) => {
          that.fullscreenLoading.close();
          if (res.data.resCode === 'C502570000000') {
            this.LoginTitle = this.$t('login.SetSuccessText')//'设置成功'
            this.$store.commit('login', res);
            this.visible = false
          }
        }).catch(function (error) {
          that.fullscreenLoading.close();
        });
      }
    },
    SetUpSuccessBtn() { // 设置密码成功弹出框显示
      let PassWordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,9}$/ // 6-9位数字字母混合正则验证
      if (!PassWordReg.test(this.SetPassWord)) {
        this.ErrorTips = this.$t('login.passwordTip')//'请输入正确格式密码'
        return
      }
      if (this.SetPassWord !== this.SetEndPassWord) {
        this.ErrorTips = this.$t('login.passwordErrorTip')//'密码输入不一致'
        return
      }
      this.$axios.post(this.apiUrl.API.RegisterReg, {
        regType: this.registerType,
        email: this.RegisterCode,
        captchaFlowNo: this.captchaFlowNo,
        loginPwd: this.SetPassWord,
        captchaCode: this.code
      })
        .then((res) => {
          if (res.data.resCode === 'C502570000000') {
            this.LoginTitle = this.$t('login.SetSuccessText')//'设置成功'
            this.$store.commit('login', res);
            this.visible = false
          }
        })
    },
    Login() { // 登入
      let that = this
      let reqObj = {
          loginPwd: this.LoginPassWord,
          regType: this.loginType,
          terminalType: 'APP_GAME_SHOP'
        }
      if(this.loginType == 'SMS'){
        if (!this.phoneNumber || !this.LoginPassWord) {
          this.ErrorTips = this.$t('login.inputaccpass')//'请输入账号密码'
          return
        }
        reqObj.mobile = this.phoneNumber
      }else if(this.loginType == 'EMAIL'){
        if (!this.LoginEmail || !this.LoginPassWord) {
          this.ErrorTips = this.$t('login.inputaccpass')//'请输入账号密码'
          return
        }
        reqObj.email = this.LoginEmail
      }
      this.openFullScreen()
        this.$axios.post(this.apiUrl.API.Login,reqObj )
          .then((res) => {
            that.fullscreenLoading.close();
            if (res.data.resCode === 'C502570000000') {
              this.$store.commit('login', res);
              this.visible = false
            } else {
              this.ErrorTips = res.data.resMsg
            }
          }).catch(function (error) {
            that.fullscreenLoading.close();
          });
    },
    LogInShow(LoginGo, RegisterGo, RegisterCodeGo, SetPassWordGo, SetUpSuccessGo) {
      this.LoginGo = LoginGo // 登入模态框显示
      this.RegisterGo = RegisterGo // 注册/忘记密码模态框显示
      this.RegisterCodeGo = RegisterCodeGo // 输入验证码模态框显示
      this.SetPassWordGo = SetPassWordGo // 设置密码模态框显示
      this.SetUpSuccessGo = SetUpSuccessGo // 设置密码成功模态框显示
      this.ErrorTips = '' // 错误信息清空
      this.LoginEmail = '' // 清空账号
      this.LoginPassWord = '' // 清空密码
      this.SetPassWord = '' // 清空设置密码
      this.SetEndPassWord = '' // 清空确认密码
    },
    closed() {
      this.LoginTitle = this.$t('login.sign')//'登入'
      this.LogInShow(true, false, false, false, false)
    },
    LoginGoBtn() { // 登入弹出框显示
      this.LoginTitle = this.$t('login.sign')//'登入'
      this.LogInShow(true, false, false, false, false)
    },
    RegisterGoBtn(RegisterClass) { // 注册弹出框显示
      this.RegisterCode = ''
      this.LogInShow(false, true, false, false, false)
      if (RegisterClass === 'zc') { // 注册
        this.LoginTitle = this.$t('login.register')//'注册'
        this.RegisterClassBtnText = this.$t('login.emailReg')//'电子邮件验证和注册'
        clearInterval(this.interval)
        this.second = this.$t('login.resend60s')//'60秒后可重新发送'
      } else { // 忘记密码
        this.LoginTitle = this.$t('login.forpassword')//'忘记密码'
        this.RegisterClassBtnText = this.$t('login.sendRePasswordEmail')//'发送重置密码邮件'
      }
    },
    RegisterCodeGoBtn() { // 验证码弹出框显示
      this.LoginTitle = this.$t('login.vcode')//'验证码'
      this.LogInShow(false, false, true, false, false)
      this.CountDown()
      this.code = '' // 验证码输入框清空
    },
    CountDown() { // 验证码倒计时
      let second = 60
      this.interval = setInterval(() => {
        second--
        this.second = second + this.$t('login.sresend')//'秒后可重新发送'
        console.log(second, this.interval)
        if (second <= 0) {
          clearInterval(this.interval)
          this.second = this.$t('login.resend')//'重新发送'
        }
      }, 1000)
      console.log(this.interval)
    },
    ResendBtn() { // 重新发送验证码
      this.second = this.$t('login.resend60s')//'60秒后可重新发送'
      this.RegisterCodeBtn()
    },
    CodeChangFouce() { // 验证码自动聚焦到input
      this.$nextTick(() => {
        this.$refs.CodeInputs.focus()
      })
    },
    toArge() { // 跳转到协议
      this.visible = false
      this.$router.push({
        path: `/dieu-khoan`
      })
    },
    getCode(e) {
      if (this.getCodeShow) return
      let that = this
      this.getCodeBtnLoading = true
      // 发送短信验证码0967202620
      let reg = /^\d{10}$/
      if (reg.test(this.phoneNumber)) {
        this.ErrorTips = ""
        this.$axios.post(this.apiUrl.API.sendCaptchasms, {
          type: "REG",
          smsType: this.codeChannelRadio,
          mobile: this.phoneNumber
        }).then((res) => {
          that.getCodeBtnLoading = false
          if (res.data.resCode === 'C502570000000') {
            this.sleep(60);
          }
        }).catch(function (error) {
          that.getCodeBtnLoading = false
        });
      } else {
        that.getCodeBtnLoading = false
        this.ErrorTips = "Vui lòng nhập số điện thoại 10 chữ số"//请输入10位手机号码
      }
    },
    async sleep(second) {
      for (let i = second; i >= 0; i--) {
        if (i == 0) {
          this.getCodeShow = false
        } else {
          this.getCodeCount = i
          this.getCodeShow = true
        }
        await this.sleepTool(1000);
      }
    },
    sleepTool(interval) {
      return new Promise(resolve => {
        setTimeout(resolve, interval);
      })
    }
  }
}
</script>



<style lang="less" scoped>
/deep/ .el-button--primary {
  background-color: #f56c6c;
  border-color: #f56c6c;
}

/deep/ .el-radio-button {
  width: 50%;
}

/deep/ .el-radio-button--small .el-radio-button__inner {
  width: 100%;
}

.dialog-title {
  img {
    width: 150px;
  }

  p {
    font-size: 18px;
  }
}

.DisplayFlex {
  display: flex;
  justify-content: center;
  margin: 0 40px 15px 40px;
}

.DisplayFlex.loginbtn {
  justify-content: space-between;
}

.Reg-box .DisplayFlex {
  margin: 0 40px;
}

.registerBtn {
  background: #fff;
  color: #f56c6c;
}

.el-input {
  width: 100%;
}

.el-button {
  padding: 8px 30px;
}

.LoginPassWord {
  text-align: right;
}

.Reg-box .LoginPassWord {
  margin: 30px 0 0 0;
  text-align: center;
}

.vcode-box .DisplayFlex {
  display: block;
  text-align: center;
}

.setPassWord-box .DisplayFlex {
  display: block;
  text-align: center;
}

.RegisterCodeText {
  text-align: left;
  font-size: 18px;
  padding-left: 15px;
}

.RegisterEmailText {
  text-align: left;
  font-size: 14px;
  padding-left: 32px;
  color: #999;
  line-height: 30px;
  letter-spacing: 1;
}

.code-input-input {
  width: 100%;
  height: 52px;
  position: absolute;
  outline: none;
  opacity: 0;
}

.code-input-main {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 20px;
}

.code-input-main-item {
  width: 50px;
  height: 50px;
  opacity: 0.8;
  border: 1px solid #ccc;
  text-align: center;
  font-size: 22px;
  line-height: 50px;
}

.code-input-main-item-border {
  border: 1px solid blue;
}

.NextCodeTop {
  margin-top: 10px;
}

.CursorPointer {
  cursor: pointer;
}

.SetPassWordCont {
  // text-align: left;
  // padding-left: 32px;
}

.SetPassWordCont>.el-input {
  margin-top: 15px;
  width: 80%;
}

.SetUpSuccessIcon {
  display: block;
  text-align: center;
}

.SetUpSuccessIcon>span {
  font-size: 100px;
  color: green;
}

.SetUpSuccessIcon>div {
  font-size: 18px;
  margin-top: 10px;
}

.TipsText {
  position: relative;
  color: red;
  text-align: center;
  margin: 0 10px 15px 10px;
  font-size: 14px;

  span {
    text-align: center;
    display: block;
    height: 15px;
  }

  p {
    em {
      cursor: pointer;
      font-style: normal;
    }

    color: #13b9c8;
    text-align: right;
    font-size: 1.2rem;
  }
}

.moreWaysLogin {
  margin: 30px 0 0 0;
  padding: 15px 0 0 0;
  border-top: 1px solid #bbb;
}

.agre {
  text-align: center;
  margin-top: 10px;
  cursor: pointer;
  color: #f56c6c;
}
</style>

<style>
.my-el-dialog .el-dialog {
  width: 500px;
}

.loginbtn .el-button {
  width: 150px;
}

.my-el-dialog .el-dialog__body {
  position: relative;
  padding: 10px 40px 20px 40px;
}

.my-el-dialog .el-dialog__header {
  padding: 20px 30px 10px;
}

@media (max-width: 768px) {
  .loginbtn .el-button {
    width: 90px;
    padding: 5px;
  }

  .my-el-dialog .el-dialog {
    width: 310px;
  }

  .my-el-dialog .el-dialog__body {
    padding: 10px 15px 20px 15px;
  }

  .vcode-box .DisplayFlex {
    margin: 0;
  }

  .setPassWord-box .DisplayFlex {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue